import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getProfileDetail() {
	return client.get("user/profile/detail");
}

function createStore(params) {
	return client.post("user/store/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function editProfile(params) {
	return client.post("user/profile/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function editProfileMLM(params) {
	return client.post("user/profile/edit-internal", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function uploadImage(params) {
	return client.post("user/profile/upload-image", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		},
	});
}

function editPassword(params) {
	return client.post("user/profile/edit-password", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function editUsername(params) {
	return client.post("user/profile/edit-username", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function editMobilephone(params) {
	return client.post("user/profile/edit-mobilephone", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function checkMLM(params) {
	return client.get("user/profile/check-member", {
		params: params,
	});
}

function checkKTPMember(params) {
	return client.get("user/profile/check-ktp-member", {
		params: params,
	});
}

function loginMLM() {
	return client.get("user/profile/login-mlm");
}

function getTypeMember() {
	return client.get("user/profile/get-type-list");
}

function getBankProspect(argument) {
	return client.get("user/profile/get-list-bank-prospect");
}

function getProspect() {
	return client.get("user/profile/get-prospect");
}

function saveProspect(params) {
	return client.post("user/profile/save-prospect", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getProfileDetail,
	createStore,
	editProfile,
	editProfileMLM,
	uploadImage,
	editPassword,
	editUsername,
	editMobilephone,
	checkMLM,
	checkKTPMember,
	loginMLM,
	getTypeMember,
	getBankProspect,
	getProspect,
	saveProspect,
};